import { render } from "./RoundImage.vue?vue&type=template&id=5a12324c"
import script from "./RoundImage.vue?vue&type=script&lang=js"
export * from "./RoundImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__